import React from "react";
import "./About.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const employees = [
  {
    nameKey: "employees.stefan.name",
    titleKey: "employees.stefan.title",
    image: "stefan.jpeg",
    descriptionKey: "employees.stefan.description",
  },
  {
    nameKey: "employees.tanya.name",
    titleKey: "employees.tanya.title",
    image: "tanya.png",
    descriptionKey: "employees.tanya.description",
  },
];

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about-container">
      <section className="about-container__intro">
        <img
          className="about-container__intro-image"
          src="/Images/about.jpg"
          alt={t("about.intro.alt")}
        />
        <p className="about-container__intro-text">{t("about.intro.short")}</p>
        <span className="about-container__dot"></span>
        <p className="about-container__intro-us">{t("about.intro.long")}</p>
        <span className="about-container__dot"></span>
      </section>

      <section className="team">
        <h2 className="heading">{t("about.team.title")}</h2>
        {employees.map((employee, index) => (
          <div
            key={index}
            className={`team__container ${
              index % 2 === 0
                ? "team__container--image-right"
                : "team__container--image-left"
            }`}
          >
            <div className="team__image-wrapper">
              <img
                className="team__image"
                src={`/Images/${employee.image}`}
                alt={t(employee.nameKey)}
              />
            </div>

            <div className="team__text-wrapper">
              <h2 className="team__title">{t(employee.nameKey)}</h2>
              <p className="team__role">{t(employee.titleKey)}</p>
              <p className="team__description">{t(employee.descriptionKey)}</p>
            </div>
          </div>
        ))}
        <Link to="/contact">
          <button className="team__cta">{t("about.team.cta")}</button>
        </Link>
      </section>
    </div>
  );
};

export default About;
